import { Box, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import GroupTable from "../../components/groupLoanComponent/groupLoanTable";
import CreateGroup from "../../components/groupLoanComponent/createGroupLoan";
import GroupCustomerTable from "../../components/groupCustomerComponent/groupCustomerTable";
import CreateGroupCustomer from "../../components/groupCustomerComponent/createGroupCustomer";

function GroupCustomer() {
  const navigate = useNavigate();
  return (
    <>
      {" "}
      <div>
        <Box sx={{ display: "flex" }}>
          <Sidebar />
          <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
            <Box height={65} />
            <Box>
              <Typography variant="h4">Group Customer</Typography>
            </Box>

            <Box mt={1}>
              {/* Nested Routes will be rendered here  */}
              <Routes>
                <Route path="/" element={<GroupCustomerTable />} />
                <Route
                  path="/create-group-customer"
                  element={<CreateGroupCustomer />}
                />
                {/* <Route path="/:id" element={<CustomerDetails />} />
                <Route path="/overview/:id" element={<OverviewTabs />} /> */}
              </Routes>
            </Box>
          </Box>
        </Box>
        {/* Outlet is used for rendering nested routes if further nesting is needed */}
        <Outlet />
      </div>
    </>
  );
}

export default GroupCustomer;
